import { render, staticRenderFns } from "./configuration-ontologies.vue?vue&type=template&id=3c37b077&scoped=true&"
import script from "./configuration-ontologies.ts?vue&type=script&lang=ts&"
export * from "./configuration-ontologies.ts?vue&type=script&lang=ts&"
import style0 from "./configuration-ontologies.scss?vue&type=style&index=0&id=3c37b077&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c37b077",
  null
  
)

export default component.exports